module.exports = __webpack_public_path__ + "static/img/home-logo.f32b971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-logo.png
// module id = XLVb
// module chunks = 21